import Smooch from 'smooch'
import { useEffect } from 'react'

const SupportChat = (): JSX.Element | null => {
  // @ts-ignore
  const integrationChatId: string = process.env.INTEGRATION_CHAT_ID

  useEffect(() => {
    // @ts-ignore
    !(function (o, p, s, e, c) {
      let i: any,
        a: any,
        h: any = []
      const d: any = []
      const u: any = []
      const t = () => {
        const t = 'You must provide a supported major version.'
        try {
          if (!c) throw new Error(t)
          let e
          const n = 'https://cdn.smooch.io/'
          const r = 'smooch'
          // @ts-ignore
          if ((e = 'string' == typeof this.response ? JSON.parse(this.response) : this.response).url) {
            const o = p.getElementsByTagName('script')[0],
              s = p.createElement('script')
            s.async = !0
            const i = c.match(/([0-9]+).?([0-9]+)?.?([0-9]+)?/),
              a = i && i[1]
            if (i && i[3]) s.src = n + r + '.' + c + '.min.js'
            else {
              // @ts-ignore
              if (!(4 <= a && e['v' + a])) throw new Error(t)
              s.src = e['v' + a]
            } // @ts-ignore
            o.parentNode.insertBefore(s, o)
          }
        } catch (e: any) {
          e.message === t && console.error(e)
        }
      }
      // @ts-ignore
      ;(o[s] = {
        init: function () {
          i = arguments
          const t = {
            then: function (e: any) {
              return d.push({ type: 't', next: e }), t
            },
            catch: function (e: any) {
              return d.push({ type: 'c', next: e }), t
            }
          }
          return t
        },
        on: function () {
          u.push(arguments)
        },
        render: function () {
          a = arguments
        },
        destroy: function () {
          h = arguments
        }
      }), // @ts-ignore
        (o.__onWebMessengerHostReady__ = function (e: any) {
          // @ts-ignore
          if ((delete o.__onWebMessengerHostReady__, (o[s] = e), i))
            for (let t = e.init.apply(e, i), n = 0; n < d.length; n++) {
              const r = d[n]
              t = 't' === r.type ? t.then(r.next) : t.catch(r.next)
            }
          a && e.render.apply(e, a), h && e.destroy.apply(e, h)
          for (let n = 0; n < u.length; n++) {
            e.on.apply(e, u[n])
          }
        })
      const n = new XMLHttpRequest()
      n.addEventListener('load', t),
        n.open('GET', 'https://' + e + '.webloader.smooch.io/', !0),
        (n.responseType = 'json'),
        n.send()
    })(window, document, 'Smooch', integrationChatId, '5')
    Smooch.init({ integrationId: integrationChatId, integrationOrder: [] })
  }, [])
  return null
}

export default SupportChat
